import actionCreatorFactory from "typescript-fsa";
const actionCreator = actionCreatorFactory('iceClient');
export const login = actionCreator.async('LOGIN');
export const reconnect = actionCreator.async('RECONNECT');
export const reconnectScheduled = actionCreator('RECONNECT_SCHEDULED');
/**
 * Started when session becomes active.
 * Done when session is closed and relogin is required.
 * Failed when unexpected error happens and reconnect is required.
 */
export const session = actionCreator.async('SESSION');
export const tokenRefreshed = actionCreator('TOKEN_REFRESHED');



//////////////////
// WEBPACK FOOTER
// ./~/@neolab/ice-client/es/actions.js
// module id = 167
// module chunks = 0